import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Tranche } from './../../model/tranche.model';
import { MascaraCnaeImpedido } from './../../model/mascara-cnae-impedido.model';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CnaeImpedidoService extends FgiBackEndService<MascaraCnaeImpedido>{

  getNewEntity() {
    return undefined;
  }

  protected getResourceURL(): string {
    return 'front/mascara-cnae-impedido';
  }

  public buscarTodosVigentesPorTranche(ideTranche: number): Observable<Array<MascaraCnaeImpedido>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tranche/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaeImpedido>>;
  }

  public buscarTodosPorTranche(ideTranche: number): Observable<Array<MascaraCnaeImpedido>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tranche/todos/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaeImpedido>>;
  }

  public buscarTodosComFiltro(ideTranche: number, params?: any): Observable<Array<MascaraCnaeImpedido>>{
    const options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/filtros/tranche/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<any>>;
  }

  public buscarTodosAtivos(ideTranche: number): Observable<Array<MascaraCnaeImpedido>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tranche/ativos/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaeImpedido>>;
  }

  public encerrarVigenciaCnaeImpedido(ideMascaraCnaeImpedido: number): Observable<Array<MascaraCnaeImpedido>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/${ideMascaraCnaeImpedido}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaeImpedido>>;
  }

  public incluir(ideTranche: number, dto: MascaraCnaeImpedido): Observable<Array<MascaraCnaeImpedido>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/tranche/${ideTranche}`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<MascaraCnaeImpedido>>;
  }



}
